<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import InputBox from '../../components/InputBox.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'SurveyQ2',
  components: {
    InputBox,
    Button: SolutoButton
  },
  computed: {
    ...mapGetters([
      'recommendationComment',
      'isCallSurvey'
    ])
  },
  methods: {
    ...mapActions([
      'changeRecommendationComment',
      'changePermission'
    ]),
    saveText (event: string) {
      this.changeRecommendationComment(event);
    },
    nextScreen () {
      if (this.isCallSurvey) {
        router.push({ path: '/survey/question3/' });
      } else {
        router.push({ path: '/survey/question5Faq/' });
      }
    },
    goBack () {
      this.changePermission(false);
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q2">
        <p class="with-margin">{{ isCallSurvey ? $t('survey_02_01_call') : $t('survey_02_01') }}</p>
        <input-box @change="saveText" :text="recommendationComment"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
